<script>
  import { slide } from 'svelte/transition';
  import LoginBackground from './LoginBackground.svelte';
  import { tv2Logo } from './Icons';
  import { channel } from '../Chat/chat-store';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<div
  class="choose-login-container"
  class:news={$channel && $channel.category === 'news'}
  class:sport={$channel && $channel.category === 'sport'}
  class:entertainment={$channel && $channel.category === 'entertainment'}
  in:slide
>
  <LoginBackground
    icon={tv2Logo}
    height="150"
    iconMarginTop="-70"
    on:close={() => dispatch('close')}
  />
  <div class="content">
    <h1>Velkommen til <span class="helper-nowrap">TV 2s</span> livechat</h1>
    <div class="rules">
      <div class="rule">
        <span class="number">1</span><span class="text">Oppfør deg pent</span>
      </div>
      <div class="rule">
        <span class="number">2</span><span class="text"
          >Gode kommentarer kan bli tatt med på sending</span
        >
      </div>
      <div class="rule">
        <span class="number">3</span><span class="text"
          >Du er velkommen til å sende inn spørsmål eller kommentarer. Trakassering, hatefulle
          meninger og trusler tillates ikke.</span
        >
      </div>
      <div class="rule">
        <span class="number">4</span><span class="text"
          >Samtlige innlegg som publiseres modereres av <span class="helper-nowrap">TV 2</span> for å
          sørge for at alle innlegg er i tråd med våre retningslinjer</span
        >
      </div>
      {#if $channel && $channel.political}
        <div class="rule">
          <span class="number" /><span class="text"
            ><a href="https://www.tv2.no/om-tv-2/14204719/" target="_blank"
              >TV 2s retningslinjer for chat</a
            ></span
          >
        </div>
      {/if}
    </div>
    <button class="ok-button" on:click={() => dispatch('user-confirmed-good-behaviour')}>
      {#if $channel && $channel.political}
        Godta
      {:else}
        Jeg lover å oppføre meg
      {/if}
    </button>
  </div>
</div>

<style src="./chatRules.scss"></style>
